module.exports = __webpack_public_path__ + "img/7.3d2097d0.png";